var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { SlhCoreIcon } from "@slhuiicon/icon-core";
import { style } from "./assets/icon.generated-style";
/**
 * Allow users to use icons
 *
 * @CustomElement slh-icon
 *
 * @cssprop --slh-color-primary - Icon primary color.
 * @cssprop --slh-color-success - Icon success color.
 * @cssprop --slh-color-info - Icon info color.
 * @cssprop --slh-color-warning - Icon warning color.
 * @cssprop --slh-color-error - Icon error color.
 */
let SlhIcon = class SlhIcon extends SlhCoreIcon(LitElement) {
};
SlhIcon.styles = style;
SlhIcon = __decorate([
    customElement("slh-icon")
], SlhIcon);
export default SlhIcon;
